import { connect } from 'react-redux';
import { AccountSelectContainer as Component } from './AccountSelectContainer';
import { ERegisterOrAuthByTokenStatus } from '../../../../types/phoneAuth/registerOrAuthorizeByToken';
import { authenticateByToken, registerOrAuthorizeByToken } from '../../../../actions/phoneAuth';
import { EAuthenticateByTokenStatus } from '../../../../types/phoneAuth';
import { changeView as _changeView } from '../../../../actions/view';
export function mapStateToProps(state) {
  var _state$phoneAuth$regi = state.phoneAuth.registerOrAuth,
    accounts = _state$phoneAuth$regi.accounts,
    phoneАccounts = _state$phoneAuth$regi.phoneАccounts;
  var _state$phoneAuth$auth = state.phoneAuth.authenticateByToken,
    account = _state$phoneAuth$auth.account,
    authByTokenStatus = _state$phoneAuth$auth.status;
  var status = state.phoneAuth.registerOrAuthByToken.status;
  var phone = state.phoneAuth.phone;
  var view = state.view,
    source = state.source;
  return {
    view: view,
    source: source,
    phone: phone,
    accounts: accounts,
    phoneАccounts: phoneАccounts,
    loadableAccount: account,
    continueByAccountLoading: authByTokenStatus === EAuthenticateByTokenStatus.Loading,
    continueByPhoneLoading: status === ERegisterOrAuthByTokenStatus.Loading
  };
}
export function mapDispatchToProps(dispatch) {
  return {
    continueByAccount: function continueByAccount(params) {
      dispatch(authenticateByToken(params));
    },
    continueByPhone: function continueByPhone() {
      dispatch(registerOrAuthorizeByToken());
    },
    changeView: function changeView(view, data) {
      dispatch(_changeView(view, data));
    }
  };
}
export var AccountSelectContainer = connect(mapStateToProps, mapDispatchToProps)(Component);